import React from "react";
import { cn } from "../../../common/u1/cn";
import { GemIcon } from "../../../../assets/ui/icons";

/* The Membership page's title block — the design's `.mem-head`.
 *
 * Static copy, but both lines are props so the same block can head a variant of
 * this screen without a second component.
 */
export const MembershipHeader = ({
  title = "Membership",
  intro = "Your TREVEX plan, your verification status, and what each one unlocks for this company.",
  className = "",
}) => (
  <div className={cn("flex items-start gap-3.5", className)}>
    <span className="mt-0.5 shrink-0 flex text-[var(--coral)]">
      <GemIcon size={30} />
    </span>
    <div className="min-w-0">
      <h2 className="m-0 text-[26px] font-bold tracking-[-.01em] text-[var(--ink)] font-sans">
        {title}
      </h2>
      {intro && (
        <p className="mt-1.5 mb-0 max-w-[560px] text-[14.5px] leading-[1.5] text-[var(--ink-2)] font-sans">
          {intro}
        </p>
      )}
    </div>
  </div>
);

export default MembershipHeader;
